module.exports = __webpack_public_path__ + "assets/img/dayu_m_online.b8628d40.png";